'use client';

import { Navigation } from '@/components/navigation';
import { Footer } from '@/components/footer';
import { motion } from 'framer-motion';
import Image from 'next/image';
import { useState } from 'react';

const fadeInUp = {
  initial: { opacity: 0, y: 20 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true },
  transition: { duration: 0.5 },
};

// Menu data structure with actual dishes
const menuData = {
  food: [
    {
      category: 'ENTRÉES',
      image: '/images/uploads/7b4fca75-15bd-455f-911c-502203e0b673.jpg',
      items: [
        { name: 'CAPRESE', price: '€10,90', description: '' },
        { name: 'CARPACCIO DE BRESAOLA', price: '€15,90', description: '' },
        { name: 'CRUDO DI PARMA E BUFALA', price: '€18,90', description: '' },
      ],
    },
    {
      category: 'BRUSCHETTONE',
      image: '/images/uploads/466c62ed-d7a6-4682-af60-256a11ac443b.jpg',
      items: [
        { name: 'VEGETARIENNE', price: '€13,90', description: 'Pain grillé, courgettes grillées et champignons à l\'huile (1.3.7.8)' },
        { name: 'DEL BRIGANTE', price: '€14,90', description: 'Pain grillé, nduja et scamorza fumée (1.3.5.7.8)' },
        { name: 'BUFALINA', price: '€17,90', description: 'Pain grillé, mortadelle grillée, mozzarella di bufala, éclats de pistaches (1.3,5,7.8)' },
        { name: 'POMODORO', price: '€12,90', description: 'Pain grillé, tomates cerises, origan, huile d\'olive (1.3.5,6,8)' },
      ],
    },
    {
      category: 'FOCACCIA & PANINI',
      image: '/images/uploads/2e7c0e21-1230-48b3-9c57-b31e56819938.jpg',
      items: [
        { name: 'FOCACCIA À LA TRUFFE', price: '€18,50', description: 'Mortadelle IGP, burrata, tomates séchées (1.3,5,6,7,8)' },
        { name: 'PANINI MARADONA', price: '€13,90', description: 'Pain puccia, saucisse fraîche toscane, brocolis-raves, mozzarella, mayonnaise (1.3,5,6.7.8)' },
        { name: 'PORCELLINO', price: '€14,90', description: 'Pain puccia, porchetta, oignons caramélisés, salade, mayonnaise (1.3,5,6.7.8)' },
        { name: 'GUANCIALINO', price: '€12,90', description: 'Pain puccia, guanciale, pecorino, miel (1.3,5,6,7,3)' },
      ],
    },
    {
      category: 'PLANCHES A L\'ITALIENNE',
      image: '/images/uploads/dd84591a-f780-4ce0-8505-94ca10ace128.jpg',
      items: [
        { name: 'Planche de fromages', price: '€20,90', description: '' },
        { name: 'Petite planche mixte', price: '€12,90', description: '' },
        { name: 'Moyenne planche mixte', price: '€22,90', description: '' },
        { name: 'Grande planche mixte', price: '€32,90', description: '' },
      ],
    },
    {
      category: 'PINSA ROMANA & PIADINA',
      image: '/images/uploads/d74c613d-8928-4b37-a966-4433ca6c6eb4.jpg',
      items: [
        { name: 'PINSA ROMANA', price: '€7,90', description: '(1.3.5,7.8.10)' },
        { name: 'PIADINA (pinsa blanche)', price: '', description: '' },
        { name: 'Sans gluten', price: '€11,90', description: '' },
      ],
    },
    {
      category: 'HAMBURGER',
      image: '/images/uploads/51d07ecc-530c-468b-b5e0-ba70e5e011eb.jpg',
      items: [
        { name: 'HAMBURGER', price: '€10,90', description: 'Buns frais & burger black Angus (1.3.5.6.7.8)' },
      ],
      note: 'Sauces aux choix : ketchup, mayonnaise, barbecue, andalouse, samouraï, burger, rosa, tabasco (1.2.3,4.5,6,7,8.9, 10, 11, 12,13,14)',
    },
    {
      category: 'PÂTES',
      image: '/images/uploads/efa1c6f9-d3b9-4cda-8eca-d4db3de35887.png',
      items: [
        { name: 'Penne Arrabiata', price: '€13,90', description: '(1,3)' },
        { name: 'Penne Bolognaise', price: '€14,90', description: '(1,3)' },
        { name: 'Paccheri Carbonara', price: '€14,90', description: '(1,3,7)' },
        { name: 'Rigatoni Cacio e Pepe', price: '€13,90', description: '(1,3,7)' },
        { name: 'Linguine Vongole', price: '€19,90', description: '(1,2,3,4,7,14)' },
        { name: 'Casarecce Calabrese', price: '€19,90', description: 'Nduja, burrata, sauce tomate, basilic (1,3,5,7,8)' },
        { name: 'Trofie al pesto', price: '€16,90', description: '(1,3,5,7,8)' },
      ],
    },
    {
      category: 'GRATINEE',
      image: '/images/uploads/56ff2260-3610-4127-9c2e-96daa8b15dfa.jpg',
      items: [
        { name: 'Lasagne', price: '€16,90', description: '(1,2.7)' },
        { name: 'Parmigiana', price: '€15,90', description: 'Aubergines, mozzarella, basilic, parmesan, sauce tomate (7)' },
      ],
    },
    {
      category: 'PLATS',
      image: '/images/uploads/259b0e7c-bb03-4723-95e5-99f3bf9e2fb5.jpg',
      items: [
        { name: 'Escalope milanaise', price: '€22,50', description: 'frites, légumes (1,3,5,6,7,5)' },
        { name: 'Cordon bleu crème champignons', price: '€24,50', description: 'spaghetti, tomate, légumes (1,3,5,6, 7,8)' },
        { name: 'Arrosticini d\'agneau', price: '€1,80 pièce', description: '' },
        { name: 'Tagliata de poulet', price: '€25,50', description: 'roquette, tomates cerises, mozzarella fraiche, légumes (1,3, 5,8,7,8)' },
        { name: 'Côte à l\'os de bœuf', price: '€45,00', description: 'légumes, frites de patates douces (1,3,5,6, 7,8)' },
        { name: 'Polpettes al sugo', price: '€15,90', description: 'Viande hachée, œuf, pain hachée, basilic, parmesan, sauce tomate (1,3,5,6,7,0)' },
        { name: 'Uovo alla carbonara', price: '€12,90', description: 'Oeuf, guanciale, poivre noir, pecorino, pain grillé (1,3,5,7,8)' },
      ],
    },
    {
      category: 'DESSERTS',
      image: '/images/uploads/5bde3aa2-8206-433b-9a7f-9a8bab882b9e.jpg',
      items: [
        { name: 'Baba au rhum avec ricotta', price: '€8', description: '(1,3,5,7,8, 12)' },
        { name: 'Tiramisu', price: '€8', description: '(1,3,5,7,8)' },
        { name: 'Cannoli ricotta sicilien', price: '€8', description: '(1,3,5,7,8)' },
      ],
    },
  ],
  supplements: {
    pinsa: [
      'Tomates - 1 €', 'Mozzarella - 2 €', 'Saucisse fraîche - 2 €',
      'Brocoli rave - 2 €', 'Mortadelle - 2 €', 'Burrata - 3 €', 'Pistaches -1 €',
      'Coppa - 2 €', 'Roquette - 1 €', 'Crème de burrata - 2 €',
      'Tomates séchées - 2 €', 'Nduja piquante - 1,50 €', 'Scamorza fumée - 2 €',
      'Olives - 1,50 €', 'Aubergines - 1,50 €', 'Courgettes - 1,50 €',
      'Porchetta - 3 €', 'Oignons caramélisés - 1,50 €', 'Culatello de porc - 6 €',
      'Crème d\'artichauts - 2 €', 'Champignons à l\'huile - 2 €', 'Jambon cuit - 2 €',
      'Jambon de Parme - 3 €', 'Guanciale - 2 €', 'Salami piquant - 2 €',
      'Copeaux de parmesan - 2 €', 'Œuf - 1,50 €', 'Pancetta - 2 €',
      'Poivrons - 1,50 €', 'Crème fraîche - 1,50 €',
    ],
    burger: [
      'Tomates - 1 €', 'Mozzarella - 2 €', 'Chedar - 1,50 €', 'Scamorza fumée - 2 €',
      'Salade - 1 €', 'Brocoli rave - 2 €', 'Bacon - 1.5 €', 'Roquette - 1 €',
      'Tomates séchées - 1.5 €', 'Nduja piquante - 1,50 €', 'Aubergines - 1.5 €',
      'Courgettes - 1.5 €', 'Oignons caramélisés - 1,50 €', 'Champignons à l\'huile - 1.5 €',
      'Guanciale - 2 €', 'Copeaux de parmesan - 2 €', 'Poivrons - 1,50 €', 'Miel - 1 €',
    ],
  },
  drinks: [
    {
      category: 'PRESSIONS',
      image: '/images/generated/elegant-draft-beer-photo.png',
      items: [
        { name: 'Diekirch', sizes: ['(0,30L) : 3,50€', '(0,50L) : 5,50€'] },
        { name: 'Dekirch grand cru', sizes: ['(0,25L) : 4,10€', '(0,50L) : 7,10€'] },
        { name: 'Leffe Blonde', sizes: ['(0,25L) : 4,30€', '(0,50L) : 7,50€'] },
        { name: 'Leffe Brune', sizes: ['(0,25L) : 4,20€', '(0,50L) : 7,20€'] },
        { name: 'Triple Karmeliet', sizes: ['(0,30L) : 6,10€', '(0,50L) : 8,90€'] },
        { name: 'Lupulus Blonde', sizes: ['(0,25L) : 3,90€', '(0,50L) : 6,90€'] },
        { name: 'Kwak', sizes: ['(0,30L) : 5,90€', '(0,50L) : 8,60€'] },
        { name: 'Moretti', sizes: ['(0,25L) : 4,90€', '(0,50L) : 7,20€'] },
        { name: 'Goose Island (IPA)', sizes: ['(0,30L) : 5,50€', '(0,50L) : 7,90€'] },
      ],
    },
    {
      category: 'BOUTEILLES',
      image: '/images/generated/elegant-photo-premium-european.png',
      items: [
        { name: 'Liefmans (0,25L)', price: '4,80€' },
        { name: 'Corona', price: '4,20€' },
        { name: 'Guinness', price: '5,90€' },
        { name: 'Peroni', price: '5,10€' },
        { name: 'Chimay Triple', price: '5,20€' },
        { name: 'Hoegaarden blanche', price: '3,50€' },
        { name: 'Franziskaner Weissbier', price: '5,50€' },
        { name: 'Diekirch 0%', price: '3,60€' },
      ],
    },
    {
      category: 'SOFTS',
      image: '/images/generated/elegant-product-photography-premium.png',
      items: [
        { name: 'Panna', sizes: ['(0,25L) : 3,20€', '(0,50L) : 4,20€'] },
        { name: 'San Pellegrino', sizes: ['(0,25L) : 3,50€', '(0,50L) : 4,50€'] },
        { name: 'Coca Cola / Coca Zero', price: '3,50€' },
        { name: 'Fanta / Sprite', price: '3,20€' },
        { name: 'Tea peach', price: '3,50€' },
        { name: 'JUS (pomme, ananas, fraise, peche, orange)', price: '3,70€' },
        { name: 'Schweppes (tonic, Citron, Agrumes)', price: '3,90€' },
        { name: 'Red bull', price: '4,90€' },
      ],
    },
    {
      category: 'BOISSONS CHAUDES',
      image: '/images/generated/elegant-product-photography-hot.png',
      items: [
        { name: 'Espresso', price: '2,80€' },
        { name: 'Café', price: '3,00€' },
        { name: 'Espresso Macchiato', price: '3,00€' },
        { name: 'Espresso corretto', price: '3,20€' },
        { name: 'Lait russe', price: '3,80€' },
        { name: 'Irish coffee', price: '8,90€' },
        { name: 'Café Décaféiné', price: '3,00€' },
        { name: 'Thé aux choix', price: '3,50€' },
        { name: 'Chocolat chaud', price: '3,80€' },
        { name: 'Cappuccino Italien', price: '3,80€' },
        { name: 'Cappuccino Chantilly', price: '3,80€' },
      ],
    },
    {
      category: 'APÉRITIFS',
      image: '/images/generated/elegant-product-photography-aperitif.png',
      items: [
        { name: 'Coupe Champagne', price: '14,00€' },
        { name: 'Coupe Prosecco', price: '8,50€' },
        { name: 'Kir vin blanc', price: '8,20€' },
        { name: 'Kir Prosecco', price: '9,00€' },
        { name: 'Kir Royal', price: '12,50€' },
        { name: 'Crodino / rouge', price: '5,20€' },
        { name: 'Martini Blanc / Rouge', price: '6,50€' },
        { name: 'Porto Rouge / Blanc', price: '5,80€' },
        { name: 'Campari', price: '7,50€' },
        { name: 'Vodka', price: '7,20€' },
        { name: 'Ricard', price: '7,20€' },
        { name: 'Panache', sizes: ['(0,30L) : 3,70€', '(0,50L) : 6,00€'] },
        { name: 'Picon biere', sizes: ['(0,30L) : 5,20€', '(0,50L) : 8,50€'] },
        { name: 'Monaco', sizes: ['(0,30L) : 3,90€', '(0,50L) : 6,20€'] },
      ],
    },
    {
      category: 'DIGESTIFS',
      image: '/images/uploads/50ffb847-4672-4728-80a8-98cb09894143.png',
      items: [
        { name: 'Amaro Del Capo', price: '5,50€' },
        { name: 'Averna', price: '7,50€' },
        { name: 'Amaretto', price: '7,20€' },
        { name: 'Baileys', price: '7,50€' },
        { name: 'Jägermeister', price: '5,50€' },
        { name: 'Sambuca', price: '7,50€' },
        { name: 'Limoncello', price: '7,50€' },
        { name: 'Diplomatico', price: '12,50€' },
        { name: 'Don Papa', price: '11,50€' },
        { name: 'Grappa barricata', price: '8,50€' },
      ],
    },
    {
      category: 'VINS ROUGE AU VERRE',
      image: '/images/generated/elegant-product-photography-red.png',
      items: [
        { name: 'Cirò Bruni', price: '7€' },
        { name: 'Primitivo', price: '8€' },
        { name: 'Appassimento', price: '10€' },
      ],
    },
    {
      category: 'VINS ROSÉ AU VERRE',
      image: '/images/generated/elegant-product-photography-ros.png',
      items: [
        { name: 'Il Pumo Salento', price: '6€' },
        { name: 'Ciro Bruni', price: '7€' },
        { name: 'Rosato Superior', price: '8€' },
      ],
    },
    {
      category: 'VINS BLANC AU VERRE',
      image: '/images/generated/elegant-product-photography-white.png',
      items: [
        { name: 'Cirò Bruni', price: '6€' },
        { name: 'Bianco puglia Bio', price: '7€' },
        { name: 'Chardonnay', price: '8€' },
      ],
    },
    {
      category: 'COCKTAILS',
      image: '/images/generated/elegant-product-photography-three.png',
      items: [
        { name: 'Aperol spritz', price: '10,50€' },
        { name: 'Limoncello spritz', price: '13,50€' },
        { name: 'Campari spritz', price: '13,50€' },
        { name: 'Hugo', price: '10,50€' },
        { name: 'Pina colada', price: '13,50€' },
        { name: 'Mojito', price: '13,50€' },
        { name: 'Gin Hendrix', price: '15,00€' },
        { name: 'Gin Bombay', price: '13,50€' },
        { name: 'Gin mare', price: '15,00€' },
        { name: 'Sex on the beach', price: '12,50€' },
        { name: 'Cocktail maison sans alcool', price: '10,50€' },
      ],
    },
  ],
};

export default function CartePage() {
  const [activeTab, setActiveTab] = useState<'food' | 'drinks'>('food');

  return (
    <div className="min-h-screen flex flex-col">
      <Navigation />

      {/* Page Header */}
      <section className="relative overflow-hidden bg-card py-20 border-b border-border/40">
        <div className="container mx-auto px-4 text-center">
          <motion.h1
            className="font-serif text-5xl md:text-6xl font-bold tracking-tight mb-4"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            Notre Carte
          </motion.h1>
          <motion.p
            className="text-lg text-muted-foreground max-w-2xl mx-auto"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            Découvrez notre sélection de plats italiens authentiques, préparés avec des ingrédients de qualité
          </motion.p>

          {/* Tab Navigation */}
          <motion.div
            className="flex justify-center gap-4 mt-8"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.3 }}
          >
            <button
              onClick={() => setActiveTab('food')}
              className={`px-8 py-3 rounded-lg font-semibold transition-all ${
                activeTab === 'food'
                  ? 'bg-primary text-primary-foreground shadow-lg'
                  : 'bg-background text-foreground border border-border hover:border-primary'
              }`}
            >
              Nourriture
            </button>
            <button
              onClick={() => setActiveTab('drinks')}
              className={`px-8 py-3 rounded-lg font-semibold transition-all ${
                activeTab === 'drinks'
                  ? 'bg-primary text-primary-foreground shadow-lg'
                  : 'bg-background text-foreground border border-border hover:border-primary'
              }`}
            >
              Boissons
            </button>
          </motion.div>
        </div>
      </section>

      {/* Menu Content */}
      <section className="py-20 bg-background">
        <div className="container mx-auto px-4">
          {activeTab === 'food' ? (
            <div className="space-y-20">
              {menuData.food.map((section, sectionIndex) => (
                <motion.div
                  key={section.category}
                  {...fadeInUp}
                  transition={{ delay: sectionIndex * 0.05 }}
                  className="max-w-6xl mx-auto"
                >
                  {/* Section Header with Image */}
                  <div className="flex flex-col md:flex-row gap-8 mb-12">
                    {section.image && (
                      <div className="md:w-1/3">
                        <div className="relative h-64 md:h-full rounded-lg overflow-hidden">
                          <Image
                            src={section.image}
                            alt={section.category}
                            fill
                            className="object-cover"
                          />
                        </div>
                      </div>
                    )}
                    <div className={section.image ? 'md:w-2/3' : 'w-full'}>
                      <h2 className="font-serif text-4xl font-bold mb-6 text-primary">
                        {section.category}
                      </h2>

                      {/* Items */}
                      <div className="space-y-6">
                        {section.items.map((item, itemIndex) => (
                          <motion.div
                            key={`${item.name}-${itemIndex}`}
                            initial={{ opacity: 0, x: -20 }}
                            whileInView={{ opacity: 1, x: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.4, delay: itemIndex * 0.05 }}
                            className="flex justify-between items-start gap-4 pb-4 border-b border-border/30 last:border-b-0"
                          >
                            <div className="flex-1">
                              <h3 className="dish-name text-xl mb-1">{item.name}</h3>
                              {item.description && (
                                <p className="text-sm text-muted-foreground">{item.description}</p>
                              )}
                            </div>
                            {item.price && (
                              <div className="text-xl font-semibold text-primary whitespace-nowrap">
                                {item.price}
                              </div>
                            )}
                          </motion.div>
                        ))}

                        {/* Show pinsa supplements after "Sans gluten" item for PINSA ROMANA section */}
                        {section.category === 'PINSA ROMANA & PIADINA' && (
                          <motion.div
                            initial={{ opacity: 0, x: -20 }}
                            whileInView={{ opacity: 1, x: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.4, delay: section.items.length * 0.05 }}
                            className="pt-4 mt-2"
                          >
                            <h4 className="font-semibold text-lg mb-3 text-foreground">Suppléments :</h4>
                            <div className="grid grid-cols-2 md:grid-cols-3 gap-2 text-sm text-muted-foreground">
                              {menuData.supplements.pinsa.map((supp, idx) => (
                                <div key={idx} className="flex items-center gap-2">
                                  <span className="text-primary">•</span>
                                  <span>{supp}</span>
                                </div>
                              ))}
                            </div>
                          </motion.div>
                        )}
                      </div>

                      {/* Special Notes */}
                      {section.note && (
                        <p className="text-sm text-muted-foreground mt-4 italic">{section.note}</p>
                      )}

                      {/* Show burger supplements after note for HAMBURGER section */}
                      {section.category === 'HAMBURGER' && (
                        <motion.div
                          initial={{ opacity: 0, x: -20 }}
                          whileInView={{ opacity: 1, x: 0 }}
                          viewport={{ once: true }}
                          transition={{ duration: 0.4, delay: section.items.length * 0.05 }}
                          className="pt-4 mt-2"
                        >
                          <h4 className="font-semibold text-lg mb-3 text-foreground">Suppléments :</h4>
                          <div className="grid grid-cols-2 md:grid-cols-3 gap-2 text-sm text-muted-foreground">
                            {menuData.supplements.burger.map((supp, idx) => (
                              <div key={idx} className="flex items-center gap-2">
                                <span className="text-primary">•</span>
                                <span>{supp}</span>
                              </div>
                            ))}
                          </div>
                        </motion.div>
                      )}
                    </div>
                  </div>
                </motion.div>
              ))}
            </div>
          ) : (
            <div className="max-w-4xl mx-auto space-y-16">
              {/* Wine Introduction */}
              <motion.div
                {...fadeInUp}
                className="text-center bg-card p-6 rounded-lg border border-border/40"
              >
                <p className="text-lg text-muted-foreground italic">
                  Sélection variée de vins délicats italiens
                </p>
              </motion.div>

              {menuData.drinks.map((section, sectionIndex) => (
                <motion.div
                  key={section.category}
                  {...fadeInUp}
                  transition={{ delay: sectionIndex * 0.05 }}
                  className="max-w-6xl mx-auto"
                >
                  {/* Section Header with Image */}
                  <div className="flex flex-col md:flex-row gap-8 mb-8">
                    {section.image && (
                      <div className="md:w-1/3">
                        <div className="relative h-64 md:h-full rounded-lg overflow-hidden">
                          <Image
                            src={section.image}
                            alt={section.category}
                            fill
                            className="object-cover"
                          />
                        </div>
                      </div>
                    )}
                    <div className={section.image ? 'md:w-2/3' : 'w-full'}>
                      <h2 className="font-serif text-3xl font-bold mb-8 text-primary text-center md:text-left">
                        {section.category}
                      </h2>

                      <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-4">
                        {section.items.map((item: any, itemIndex: number) => (
                          <motion.div
                            key={`${item.name}-${itemIndex}`}
                            initial={{ opacity: 0, y: 10 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.3, delay: itemIndex * 0.02 }}
                            className="flex justify-between items-start gap-3 pb-3 border-b border-border/30"
                          >
                            <div className="flex-1">
                              <p className="font-medium">{item.name}</p>
                              {item.sizes && (
                                <p className="text-sm text-muted-foreground">{item.sizes.join(' / ')}</p>
                              )}
                            </div>
                            {item.price && (
                              <div className="text-primary font-semibold whitespace-nowrap">
                                {item.price}
                              </div>
                            )}
                          </motion.div>
                        ))}
                      </div>
                    </div>
                  </div>
                </motion.div>
              ))}
            </div>
          )}

          {/* CTA to Book */}
          <motion.div
            className="text-center mt-20"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <p className="text-lg text-muted-foreground mb-6">
              Prêt à découvrir nos saveurs authentiques ?
            </p>
            <a
              href="/reserver"
              className="inline-flex items-center justify-center px-8 py-4 text-base font-semibold text-primary-foreground bg-primary rounded-lg hover:opacity-90 transition-all hover:scale-105 shadow-lg"
            >
              Réserver une Table
            </a>
          </motion.div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
